<template>
<v-card style="height:90vh">

<v-toolbar height="42" color="#242F3B" dark flat>
<v-card-title class="ma-0 pa-0">
<span v-if="creator.isEditor" style="font-size:1.4em">   Редактировать -  {{creator.newTask.name}} </span>
<span v-else style="font-size:1.4em">   Создание нового задания  </span>
</v-card-title>
<v-spacer></v-spacer>
<v-icon  @click="close()"> mdi-close</v-icon>
</v-toolbar>

<v-snackbar v-model="creator.sb.snackbar" :color="creator.sb.color" center top absolute :timeout="2000">
{{ creator.sb.text  }}
<v-btn dark flat @click="creator.sb.snackbar = false"> ОК </v-btn>
</v-snackbar>

<v-card-text>

  <v-text-field v-if="creator.isEditor" color="#4A76A8"  v-model="creator.newTask.name" label="Новое название" clearable></v-text-field>
  <v-text-field v-else color="#4A76A8"  v-model="creator.newTask.name" label="Название нового задания" clearable></v-text-field>

<div>
<b-card no-body>
<b-tabs   card>

<b-tab>

<template #title>
<v-icon small color="green">mdi-worker</v-icon> <strong style="margin-left:5px">Действия</strong>
</template>



<v-checkbox hide-details  color="#232F3A" v-model="creator.newTask.actions.messageSend.activated">
<span style="color:#232F3A;margin-top:6px" slot="label">Рассылка сообщений</span>
</v-checkbox>

<div v-if="creator.newTask.actions.messageSend.activated">
<v-layout  >
<v-flex md8>
<div style="margin:10px;margin-left:0px">
<v-textarea hide-details  solo v-model="creator.newTask.actions.messageSend.text" color="#4A76A8" label="Введите текс сообщения">
</v-textarea>
<div v-if="!creator.newTask.actions.messageSend.repostPost && !creator.newTask.actions.messageSend.repostRepost" style="margin-top:5px">  <v-text-field  solo clearable v-model="creator.newTask.actions.messageSend.attachment" color="#4A76A8" label="Прикрепление, например photo32_2"></v-text-field> </div>
</div>
</v-flex>
<v-flex md4 style="margin-top:10px">
  <v-card  style=" "><v-card-text >
  <v-checkbox v-if="!creator.newTask.actions.messageSend.repostRepost && !creator.newTask.actions.messageSend.attachment" v-model="creator.newTask.actions.messageSend.repostPost" class="pa-0 ma-0"  hide-details  color="#232F3A"  >
  <span style="color:#232F3A;margin-top:6px" slot="label">Репост личного поста</span>
  </v-checkbox>
  <v-checkbox class="pa-0 ma-0" v-if="!creator.newTask.actions.messageSend.repostPost && !creator.newTask.actions.messageSend.attachment" v-model="creator.newTask.actions.messageSend.repostRepost"   hide-details  color="#232F3A"  >
  <span style="color:#232F3A;margin-top:6px" slot="label">Репост личного репоста</span>
  </v-checkbox>
  <v-checkbox class="pa-0 ma-0" v-model="creator.newTask.actions.messageSend.deletAfter"  hide-details  color="#232F3A"  >
  <span style="color:#232F3A;margin-top:6px" slot="label">Удалить у отправителя</span>
  </v-checkbox>
</v-card-text></v-card>
</v-flex>
</v-layout>

<v-layout >
<v-flex md12>
<v-textarea hide-details  solo v-model="creator.newTask.actions.messageSend.text2" color="#4A76A8" label="Введите текс дополнительного сообщения">
</v-textarea>
</v-flex>
</v-layout>
</div>






<v-checkbox hide-details  color="#232F3A" v-model="creator.newTask.actions.friendRequest.activated">
<span style="color:#232F3A;margin-top:6px" slot="label">Заявки в друзья</span>
</v-checkbox>

<div v-if="creator.newTask.actions.friendRequest.activated" style="margin:10px;margin-left:0px">
<v-textarea clearable v-model="creator.newTask.actions.friendRequest.text" color="#4A76A8" label="Введите содержимое прикрепленного сообщения (опционально)"></v-textarea>
</div>

<div v-if="creator.newTask.actions.friendRequest.activated" style="margin:10px;margin-left:0px">
  <v-checkbox  hide-details  color="#232F3A" v-model="creator.newTask.actions.friendRequest.afterAccept.is">
  <span style="color:#232F3A;margin-top:6px" slot="label">Сообщение новым друзьям</span>
  </v-checkbox>
<v-textarea v-if="creator.newTask.actions.friendRequest.afterAccept.is" clearable v-model="creator.newTask.actions.friendRequest.afterAccept.text" color="#4A76A8" label="Сообщение после того как заявка была принята"></v-textarea>
</div>





<v-checkbox hide-details  color="#232F3A" v-model="creator.newTask.actions.postActions.activated">
<span style="color:#232F3A;margin-top:6px" slot="label">Выполнять действия списка "Мои посты"</span>
</v-checkbox>


<v-checkbox hide-details  color="#232F3A" v-model="creator.newTask.actions.unFriend.activated">
<span style="color:#232F3A;margin-top:6px" slot="label">Удалить из друзей</span>
</v-checkbox>

<v-checkbox hide-details  color="#232F3A" v-model="creator.newTask.actions.likeAvatar.activated">
<span style="color:#232F3A;margin-top:6px" slot="label">Без действия в обработанные</span>
</v-checkbox>

<v-switch disabled  v-model="creator.newTask.allActionsImportant"     class="mt-0" color="green" hide-details >
<span style="margin-top:6px" slot="label">Обязательно выполнять все выбранные действия</span>
</v-switch>

</b-tab>




<b-tab>

<template #title>
<v-icon small color="#242F3A">mdi-pencil</v-icon> <strong style="margin-left:5px">Модификация аккаунтов</strong>
</template>



<v-switch   v-model="creator.newTask.preActions.activated"     class="mt-0" color="green" hide-details >
<span style="margin-top:6px" slot="label">Активировать модификацию</span>
</v-switch>

<v-checkbox   hide-details  color="#232F3A" v-model="creator.newTask.preActions.status.is">
<span   style="color:#232F3A;margin-top:6px" slot="label">Изменить статус</span>
</v-checkbox>

<v-layout style="margin-left:-10px" v-if="creator.newTask.preActions.status.is">
<v-flex md12>
<div style="margin:10px">
<div style="margin-bottom:5px">
<v-text-field hide-details  solo clearable v-model="creator.newTask.preActions.status.text" color="#4A76A8" label="Установить статус"></v-text-field>
</div>
</div>
</v-flex>
</v-layout>

<v-checkbox   hide-details  color="#232F3A" v-model="creator.newTask.preActions.repost.is">
<span   style="color:#232F3A;margin-top:6px" slot="label">Репост контента</span>
</v-checkbox>

<v-layout style="margin-left:-10px" v-if="creator.newTask.preActions.repost.is">
<v-flex md8>
<div style="margin:10px">
  <div style="margin-bottom:5px">  <v-text-field hide-details  solo clearable v-model="creator.newTask.preActions.repost.attachment" color="#4A76A8" label="Прикрепление, например photo32_2"></v-text-field> </div>
  <v-textarea hide-details  solo v-model="creator.newTask.preActions.repost.text" color="#4A76A8" placeholder="Введите ваш текст поста, данное поле можно оставить пустым.">
  </v-textarea>
  <div v-if="creator.newTask.preActions.repost.make_comment.is" style="margin-top:5px">  <v-text-field hide-details  solo clearable v-model="creator.newTask.preActions.repost.make_comment.text" color="#4A76A8" label="Ваш комментарий"></v-text-field> </div>
</div>

</v-flex>
<v-flex md4 style="margin-top:10px">
<v-card  style=" "><v-card-text >
<v-checkbox class="pa-0 ma-0" v-model="creator.newTask.preActions.repost.pin"  hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Закрепить на стене</span>
</v-checkbox>
<v-checkbox class="pa-0 ma-0" v-model="creator.newTask.preActions.repost.close_comments"  hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Отключить комментарии</span>
</v-checkbox>
<v-checkbox class="pa-0 ma-0" v-model="creator.newTask.preActions.repost.add_like"  hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Поставить личный лайк</span>
</v-checkbox>
<v-checkbox class="pa-0 ma-0" v-model="creator.newTask.preActions.repost.make_comment.is"  hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Добавить комментарий</span>
</v-checkbox>
</v-card-text></v-card>

</v-flex>
</v-layout>




<v-checkbox   hide-details   color="#232F3A" v-model="creator.newTask.preActions.post.is">
<span   style="color:#232F3A;margin-top:6px" slot="label">Создать пост</span>
</v-checkbox>

<v-layout style="margin-left:-10px" v-if="creator.newTask.preActions.post.is">
<v-flex md8>
<div style="margin:10px">
<v-textarea rows="10" hide-details  solo v-model="creator.newTask.preActions.post.text" color="#4A76A8" placeholder="Введите шаблон тела поста. Возможно использовать рандомизацию, указав тег <tele-link>, будет сгенерирована новая телеграмм ссылка. Например: Вот  {тут|здесь} <tele-link> информация.">
</v-textarea>
<div v-if="creator.newTask.preActions.post.make_comment.is" style="margin-top:5px">  <v-text-field hide-details  solo clearable v-model="creator.newTask.preActions.post.make_comment.text" color="#4A76A8" label="Ваш комментарий"></v-text-field> </div>
</div>

</v-flex>
<v-flex md4 style="margin-top:10px">
<v-card  style=" "><v-card-text >
  <v-checkbox class="pa-0 ma-0" v-model="creator.newTask.preActions.post.pin"  hide-details  color="#232F3A"  >
  <span style="color:#232F3A;margin-top:6px" slot="label">Закрепить на стене</span>
  </v-checkbox>
  <v-checkbox class="pa-0 ma-0" v-model="creator.newTask.preActions.post.close_comments"  hide-details  color="#232F3A"  >
  <span style="color:#232F3A;margin-top:6px" slot="label">Отключить комментарии</span>
  </v-checkbox>
  <v-checkbox class="pa-0 ma-0" v-model="creator.newTask.preActions.post.add_like"  hide-details  color="#232F3A"  >
  <span style="color:#232F3A;margin-top:6px" slot="label">Поставить личный лайк</span>
  </v-checkbox>
  <v-checkbox class="pa-0 ma-0" v-model="creator.newTask.preActions.post.make_comment.is"  hide-details  color="#232F3A"  >
  <span style="color:#232F3A;margin-top:6px" slot="label">Добавить комментарий</span>
  </v-checkbox>
</v-card-text></v-card>

</v-flex>
</v-layout>


<v-checkbox hide-details  color="#232F3A" v-model="creator.newTask.preActions.privat.is">
<span style="color:#232F3A;margin-top:6px" slot="label">Приватность аккаунта</span>
</v-checkbox>

<div style="margin-bottom:15px" v-if="creator.newTask.preActions.privat.is">

  <v-select
    v-model="creator.newTask.preActions.privat.options.msgRecive.selected"
    hint="Кто может отправлять личные сообщения"
    :items="creator.newTask.preActions.privat.options.msgRecive.options"
    item-text="text"
    item-value="value"
    persistent-hint
    return-object
    single-line
  ></v-select>

  <v-select
    v-model="creator.newTask.preActions.privat.options.whoCanPost.selected"
    hint="Кто может оставлять записи на странице"
    :items="creator.newTask.preActions.privat.options.whoCanPost.options"
    item-text="text"
    item-value="value"
    persistent-hint
    return-object
    single-line
  ></v-select>

  <v-select
    v-model="creator.newTask.preActions.privat.options.whoCanComment.selected"
    hint="Кто может комментировать записи"
    :items="creator.newTask.preActions.privat.options.whoCanComment.options"
    item-text="text"
    item-value="value"
    persistent-hint
    return-object
    single-line
  ></v-select>

  <v-select
    v-model="creator.newTask.preActions.privat.options.whoCanSeeOthersComments.selected"
    hint="Кто видит комментарии к записям"
    :items="creator.newTask.preActions.privat.options.whoCanSeeOthersComments.options"
    item-text="text"
    item-value="value"
    persistent-hint
    return-object
    single-line
  ></v-select>

  <v-select
    v-model="creator.newTask.preActions.privat.options.whoCanSeeOthersPosts.selected"
    hint="Кто видит чужие записи на странице"
    :items="creator.newTask.preActions.privat.options.whoCanSeeOthersPosts.options"
    item-text="text"
    item-value="value"
    persistent-hint
    return-object
    single-line
  ></v-select>

  <v-select
    v-model="creator.newTask.preActions.privat.options.openProfile.selected"
    hint="Выберите тип профиля (временно не доступно)"
    :items="creator.newTask.preActions.privat.options.openProfile.options"
    item-text="text"
    item-value="value"
    persistent-hint
    return-object
    single-line
  ></v-select>
</div>

</b-tab>




<b-tab>
<template #title>
<v-icon small color="green">mdi-account-multiple</v-icon> <strong style="margin-left:5px">Аккаунты</strong>
</template>


<template v-if="creator.isEditor" v-slot:header>
<div> <v-icon  color="#242F3B">mdi-account-switch</v-icon>
<span  style="color:#242F3B;margin-left:20px;font-size:1.4em;font-weight:bold">Аккаунты</span>
</div>
</template>

<template v-else v-slot:header>
<div> <v-icon  color="#242F3B">mdi-account-switch</v-icon>
<span  style="color:#242F3B;margin-left:20px;font-size:1.4em;font-weight:bold">Параметры аккаунтов</span>
</div>
</template>

<v-select
@change="changeSelectedGr()"
v-model = 'creator.newTask.accGroupId'
:items="creator.newTask.accGroupsList.slice(1)"
item-text = 'title_ru'
item-value = 'gr_id'
>
<template slot="item" slot-scope="data">
{{data.item.title_ru}}
<span style="margin-left:10px;color:green" v-if="data.item.gr_id == '1' && accCount.vk_profiles[0]>0"> (<strong>{{accCount.vk_profiles[0]}}</strong>) </span>
<span style="margin-left:10px;color:red" v-if="data.item.gr_id == '1' && accCount.vk_profiles[1]>0"> (<strong>{{accCount.vk_profiles[1]}}</strong>) </span>

<span style="margin-left:10px;color:green" v-if="data.item.gr_id == '2' && accCount.vk_profiles_autoreg[0]>0"> (<strong>{{accCount.vk_profiles_autoreg[0]}}</strong>) </span>
<span style="margin-left:10px;color:red" v-if="data.item.gr_id == '2' && accCount.vk_profiles_autoreg[1]>0"> (<strong>{{accCount.vk_profiles_autoreg[1]}}</strong>) </span>

<span style="margin-left:10px;color:green" v-if="data.item.gr_id == '3' && accCount.vk_profiles_friends[0]>0"> (<strong>{{accCount.vk_profiles_friends[0]}}</strong>) </span>
<span style="margin-left:10px;color:red" v-if="data.item.gr_id == '3' && accCount.vk_profiles_friends[1]>0"> (<strong>{{accCount.vk_profiles_friends[1]}}</strong>) </span>

<span style="margin-left:10px;color:green" v-if="data.item.gr_id == '4' && accCount.vk_profiles_others[0]>0"> (<strong>{{accCount.vk_profiles_others[0]}}</strong>) </span>
<span style="margin-left:10px;color:red" v-if="data.item.gr_id == '4' && accCount.vk_profiles_others[1]>0"> (<strong>{{accCount.vk_profiles_others[1]}}</strong>) </span>
</template>
<template slot="label">
<span style="color:#FF8F18 ">Выберите группу аккаунтов</span>
</template>
</v-select>

<v-autocomplete
               v-model="creator.newTask.accounts"
               no-data-text = "Нет аккаунтов для выбора "
               :items="creator.newTask.accountsAll"
               hide-selected
               chips
               color="#4A76A8"
               item-text="title"
               item-value="id"
               multiple
>
<template slot="label">
<span style="color:#FF8F18 ">Выберите как минимум один или несколько аккаунтов</span>
</template>
             <template
              slot="selection"
              slot-scope="data"
            >
              <v-chip

                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="removeSelectedAccount(data.item)"
              >
                <v-avatar>
                  <img :src="data.item.photo_50">
                </v-avatar>
                {{ data.item.title }}
              </v-chip>
            </template>

<template slot="item" slot-scope="data">
<template v-if="typeof data.item !== 'object'">
<v-list-tile-content v-text="data.title"></v-list-tile-content>
</template>
<template v-else>
    <v-list-tile-avatar>
    <img :src="data.item.photo_50">
    </v-list-tile-avatar>
    <v-list-tile-content>
    <v-list-tile-title v-html="data.item.title"></v-list-tile-title>
    </v-list-tile-content>

    <v-spacer></v-spacer>
    <v-tooltip top v-if="data.item.info.valid == '0'">
    <span>Невалидный аккаунт</span>
    <v-btn slot="activator" icon small  ><v-icon color="red">mdi-account-minus</v-icon></v-btn>
    </v-tooltip>
    <v-tooltip top v-if="data.item.is_closed">
    <span>Закрытый аккаунт</span>
    <v-btn slot="activator" icon small  ><v-icon color="yellow">mdi-account-alert</v-icon></v-btn>
    </v-tooltip>
    <v-tooltip top v-if="JSON.parse(data.item.info.limits).friendRequest.expire">
    <span>Лимит на заявки в друзья</span>
    <v-btn slot="activator" icon small  ><v-icon color="yellow">mdi-account-multiple-plus</v-icon></v-btn>
    </v-tooltip>
    <v-tooltip top v-if="JSON.parse(data.item.info.limits).messageSend.expire">
    <span>Лимит на отправку сообщений</span>
    <v-btn slot="activator" icon small  ><v-icon color="yellow">mdi-email</v-icon></v-btn>
    </v-tooltip>
    <v-tooltip top v-if="data.item.info.my_post">
    <span>На данном аккаунте был опубликован пост</span>
    <v-btn slot="activator" icon small  ><v-icon color="gray">mdi-comment-multiple-outline</v-icon></v-btn>
    </v-tooltip>
    <v-tooltip top v-if="data.item.info.my_repost">
    <span>На данном аккаунте был опубликован репост</span>
    <v-btn slot="activator" icon small  ><v-icon color="gray">mdi-share</v-icon></v-btn>
    </v-tooltip>

</template>
</template>
</v-autocomplete>


             <v-select v-if="creator.newTask.accounts.length>1"
               color="#4A76A8"
               v-model="creator.newTask.accountSettings.mode"
               :items="creator.newTask.accountSettings.options"
             ></v-select>


<div style="color:#FF8F18">Действия при лимитах и блокировках</div>

<v-checkbox hide-details  color="#273C51" v-model="creator.newTask.stopBlock">
<span slot="label" style="margin-top:6px">Остановить задание если выбранные аккаунты блокируются / меняют пароли?</span>
</v-checkbox>

<v-checkbox hide-details color="#273C51" v-model="creator.newTask.replaceThenBlock">
<span slot="label" style="margin-top:6px">Заменить если выбранные аккаунты заблокированы / сменили пароль ?</span>
</v-checkbox>

<v-checkbox  hide-details color="#273C51" v-model="creator.newTask.stopLimit">
<span slot="label" style="margin-top:6px">Остановить задание если  на одном из аккаунтов лимит на действия ?</span>
</v-checkbox>

<v-checkbox hide-details color="#273C51" v-model="creator.newTask.replaceThenLimit">
<span slot="label" style="margin-top:6px">Заменить любым другим если  на одном из аккаунтов лимит на действия ?</span>
</v-checkbox>

<div v-if="creator.newTask.replaceThenLimit && creator.newTask.replaceThenBlock">
<div style="color:#FF8F18;margin-top:20px">Действия при последовательной блокировке</div>

<v-switch v-model="creator.newTask.sequentialBlock.is"     class="mt-0" color="green" hide-details >
<span style="margin-top:6px" slot="label">Активировать действия</span>
</v-switch>

<div v-if="creator.newTask.sequentialBlock.is">
<v-subheader>Количество последовательно заблокированных аккаунтов</v-subheader>
<v-slider hide-details
color="#4A76A8"
thumb-label="always"
v-model="creator.newTask.sequentialBlock.accCount"
max="150"
min="1"
></v-slider>

<v-checkbox hide-details color="#273C51" v-model="creator.newTask.sequentialBlock.stopTask">
<span slot="label" style="margin-top:6px">Остановить задачу</span>
</v-checkbox>

</div>
</div>

</b-tab>


<b-tab>
<template #title>
<v-icon small color="pink">mdi-database</v-icon> <strong style="margin-left:5px">Ресурсы</strong>
</template>
<v-textarea v-if="!creator.isEditor"
color="#4A76A8"
clearable v-model="creator.newTask.resources"
label="список страниц, над которыми будет выполнено задание (необязательно)"
>

</v-textarea>


<app-procBinding :init="creator.procesess"> </app-procBinding>

<v-checkbox hide-details color="#273C51" v-model="creator.newTask.exceptDuble" >
<span slot="label" style="margin-top:6px">Игнорировать повторные аккаунты</span>
</v-checkbox>

</b-tab>


<b-tab>

<template #title>
<v-icon small color="yellow">mdi-tune</v-icon> <strong style="margin-left:5px">Параметы</strong>
</template>


<v-autocomplete
            v-model="creator.filters.selected"
            no-data-text = "Нет фильтров для выбора"
            :items="creator.filters.all"
            hide-selected
            chips
            color="#4A76A8"
            item-text="title"
            item-value="id"
            multiple
          >
          <template slot="label">
          <span style="color:#FF8F18 ">Привязать фильтры</span>
          </template>
          <template
           slot="selection"
           slot-scope="data"
         >
           <v-chip
             :selected="data.selected"
             close
             class="chip--select-multi"
             @input="removeSelectedFilter(data.item.id)"
           >
             {{ data.item.name }}
           </v-chip>
         </template>

         <template
           slot="item"
           slot-scope="data"
         >
           <template>
             <v-list-tile-content>
               <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
             </v-list-tile-content>
           </template>
         </template>
          </v-autocomplete>


<div style="color:#FF8F18">Обрабака и исключение трафика</div>
<v-checkbox hide-details color="#273C51"  v-model="creator.newTask.traffControl.blockedToBots" >
<span slot="label" style="margin-top:6px">Блокированных в бот фильтр</span>
</v-checkbox>
<v-checkbox hide-details color="#273C51" v-model="creator.newTask.traffControl.removeClosedMsg" >
<span slot="label" style="margin-top:6px">Исключить закрытые сообщения</span>
</v-checkbox>
<v-checkbox hide-details color="#273C51" v-model="creator.newTask.traffControl.removeClosedFriendsReq"  >
<span slot="label" style="margin-top:6px">Исключить закрытые заявки в друзья</span>
</v-checkbox>
<v-checkbox hide-details color="#273C51" v-model="creator.newTask.traffControl.minWomen"  >
<span slot="label" style="margin-top:6px">Исключить женский пол</span>
</v-checkbox>
<v-checkbox hide-details color="#273C51" v-model="creator.newTask.traffControl.minMen"  >
<span slot="label" style="margin-top:6px">Исключить мужской пол</span>
</v-checkbox>
<v-checkbox  hide-details color="#273C51" v-model="creator.newTask.traffControl.onlyOnline"  >
<div slot="label" style="margin-top:6px">Обрабатывать только онлайн </div>
</v-checkbox>
<v-card-text>
<v-layout row v-if="creator.newTask.traffControl.onlyOnline">
<v-flex   >
<v-subheader>Максимально допустимый оффлайн в минутах</v-subheader>
<v-slider hide-details class="px-3"
color="#4A76A8"
thumb-label="always"
v-model="creator.newTask.traffControl.maxOffline"
max="360"
min="0"
></v-slider>
</v-flex>
</v-layout>
</v-card-text>






  <v-subheader style="color:#FF8F18">Минимальная и Максимальная задержка между действиями (сек.)</v-subheader>
  <v-card-text>

    <v-layout row>

      <v-flex class="px-3">
        <v-range-slider
        color="#4A76A8"
        thumb-label="always"
          v-model="creator.newTask.actionsTimeout.range"
          :max="creator.newTask.actionsTimeout.max"
          :min="creator.newTask.actionsTimeout.min"
        ></v-range-slider>
      </v-flex>

    </v-layout>
  </v-card-text>





  <v-subheader style="color:#FF8F18">Минимальная и Максимальная задержка между ресурсами (сек.)</v-subheader>
  <v-card-text>

    <v-layout row>

      <v-flex class="px-3">
        <v-range-slider
        color="#4A76A8"
        thumb-label="always"
          v-model="creator.newTask.resourcesTimeout.range"
          :max="creator.newTask.resourcesTimeout.max"
          :min="creator.newTask.resourcesTimeout.min"
        ></v-range-slider>
      </v-flex>

    </v-layout>
  </v-card-text>
</b-tab>


</b-tabs>
</b-card>
</div>


<v-btn style="text-transform:none" v-if="creator.isEditor" color="#4A76A8" :loading="creator.ui.createLoading"  flat @click="createNewTask()" block>
<v-icon> mdi-pencil </v-icon> <span style="margin-left:5px"> Редактировать задание </span>
</v-btn>
<v-btn style="text-transform:none" v-else color="#4A76A8" :loading="creator.ui.createLoading"  flat @click="createNewTask()" block>
<v-icon> mdi-plus </v-icon> <span style="margin-left:5px"> Создать задание </span>
</v-btn>



</v-card-text>




  </v-card>




</template>

<script>

import axios from 'axios'
export default {
components:{},
props: ['modals','tasks','creator'],
data () {
return {
accCount:{},
}
},
methods: {
getAccCount(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/acc_count_get.php', {
method: 'get',
}).then(response => {
this.accCount = response.data
})
},
   changeSelectedGr(){
     axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/accounts_get.php', {
          method: 'get',
          params: {grId:this.creator.newTask.accGroupId},
        }).then(response => {
      this.creator.newTask.accountsAll = response.data.filter((item, i , arr)=>{

      if(item.info.valid == "1"  && item.info.task_able == "1"){
        return true
      } else return false
    })
        })
   },


removeSelectedAccount(item) {
const index = this.creator.newTask.accounts.indexOf(item.id)
if (index >= 0) this.creator.newTask.accounts.splice(index, 1)
},
removeSelectedFilter(item) {

const index = this.creator.filters.selected.indexOf(item)
if (index >= 0) this.creator.filters.selected.splice(index, 1)
},

   messageAct(){

     if( this.creator.newTask.actions.messageSend.activated ){
       this.creator.newTask.actions.messageSend.activated = true
       this.creator.newTask.modals.message = true
     } else  {
       this.creator.newTask.actions.messageSend.activated =  false
     }
   },


    close( ){
      this.creator.isEditor = false
      this.creator.panel = [false,false,false,false]
      this.modals.creator = false
    },
    createNewTask(){

    let params = {}
      params.dynamic = {}
      params.params = {}
      params.preActions = {}
      params.preActions = this.creator.newTask.preActions
      params.params.taskId = this.creator.taskId
      params.contentType = 'pages'
      params.name = this.creator.newTask.name
      params.grId = this.creator.newTask.accGroupId
      params.accounts = this.creator.newTask.accounts
      params.actions = this.creator.newTask.actions
      params.resources = this.creator.newTask.resources
      params.params.traffControl = this.creator.newTask.traffControl
      params.params.resourcesTimeout = this.creator.newTask.resourcesTimeout
      params.params.actionsTimeout  = this.creator.newTask.actionsTimeout
      params.params.stopBlock  = this.creator.newTask.stopBlock
      params.params.stopLimit  = this.creator.newTask.stopLimit
      params.params.replaceThenBlock  = this.creator.newTask.replaceThenBlock
      params.params.replaceThenLimit  = this.creator.newTask.replaceThenLimit
      params.params.sequentialBlock  = this.creator.newTask.sequentialBlock
      params.params.exceptDuble  = this.creator.newTask.exceptDuble
      params.params.allActionsImportant  = this.creator.newTask.allActionsImportant
      params.params.accountsMode  = this.creator.newTask.accountSettings.mode
      params.dynamic.procesess = this.creator.procesess.procUpdates.selected
      params.params.filters = this.creator.filters.selected


      if(params.accounts.length<1){
        this.creator.sb.snackbar = true
        this.creator.sb.color = "error"
        this.creator.sb.text = "Выберите хотя бы один аккаунт"
      } else if (!params.actions.postActions.activated && !params.actions.friendRequest.activated && !params.actions.messageSend.activated && !params.actions.likeAvatar.activated && !params.actions.unFriend.activated  ) {
        this.creator.sb.snackbar = true
        this.creator.sb.color = "error"
        this.creator.sb.text = "Активируйте хотя бы одно действие"
      }
else {
      this.creator.ui.createLoading = true
      axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+this.creator.creationPath, {
           method: 'POST',
           data: {params:params}
         }).then(response => {
           this.creator.ui.createLoading = false

     if(response.data == 1){

       axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/task_for_export.php', {
            method: 'POST',
            data: {
              contentType: 'pages'
            }
          })
          .then( response => {
            this.tasks.loading = false
               response.data.forEach(
              (item,i,arr)=>{
                item.status = JSON.parse(item.status)
              }
            )
            this.tasks.tasksList = response.data
          })


       this.creator.sb.snackbar = true
       this.creator.sb.color = "success"
       if(this.creator.isEditor){this.creator.sb.text = "Параметры задания успешно изменены."} else {
         this.creator.sb.text = "Задание было успешно созданно. "
       }
       this.$store.dispatch('changeCounters')
       setTimeout(()=>{this.modals.creator = false}, 1000)
     } else {
       this.creator.sb.snackbar = true
       this.creator.sb.color = "error"
       this.creator.sb.text = response.data.error
     }
         })

   }
    }



  },
  computed:{

  },
  mounted(){
this.getAccCount()

axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/gr_list_get.php', {
contentType: 'JSONP',
method: 'get',
}).then(response => {
this.creator.newTask.accGroupsList = response.data
})

axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/accounts_get.php', {
method: 'get',
}).then(response => {
this.creator.newTask.accountsAll = response.data.filter((item, i , arr)=>{
if(item.info.valid == "1"  && item.info.task_able == "1"){
return true
} else return false
})
})

axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/get_processes.php', {
method: 'POST',
data: {contentType:'pages'},
}).then(response => {
this.creator.procesess.items = response.data
})

axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/filter/get_list.php', {
method: 'POST',
data: {contentType:'pages'},
}).then(response => {
this.creator.filters.all = response.data
})

  },

}
</script>

<style    >

</style>
